import { Currency } from "@redotech/money/currencies";
import { getCurrencyFormatter } from "@redotech/money/util";
import { Adjustment } from "@redotech/redo-return-core-common/return-flow";

export function getItemDetailPrice(
  item:
    | {
        exchangeRate?: number;
        presentmentCurrency?: string;
        itemValue?: string | null;
        price: string;
        quantity: number;
        currency: Currency;
      }
    | undefined,
  shouldCombinePrice: boolean,
  adjustment?: Adjustment,
  locale?: string,
) {
  if (!item) {
    return { formattedItemValue: "", itemValueNumber: 0 };
  }

  const {
    exchangeRate,
    presentmentCurrency,
    itemValue,
    price,
    quantity,
    currency,
  } = item;

  function getItemValue(price_: number, quantity: number) {
    let priceToFormat = price_;
    if (shouldCombinePrice) {
      priceToFormat = price_ * quantity;
    }
    if (adjustment) {
      priceToFormat = priceToFormat + adjustment.flat;
    }
    if (exchangeRate && exchangeRate > 0) {
      priceToFormat = priceToFormat * exchangeRate;
    }
    return priceToFormat;
  }

  function formatPrice(price_: number, currency: Currency) {
    let targetCurrency = currency;
    if (exchangeRate && exchangeRate > 0 && presentmentCurrency) {
      targetCurrency = presentmentCurrency as Currency;
    }
    return getCurrencyFormatter(targetCurrency, undefined, locale).format(
      price_,
    );
  }

  const itemValueNumber = getItemValue(Number(itemValue), quantity);
  const formattedItemValue = formatPrice(itemValueNumber, currency);

  let formattedPrice;

  let discountFormatted = undefined;
  if (Number(price) !== Number(itemValue)) {
    discountFormatted = getCurrencyFormatter(
      currency,
      undefined,
      locale,
    ).format(Number(price) - Number(itemValue));
    formattedPrice = formatPrice(
      getItemValue(Number(price), quantity),
      currency,
    );
  }
  return {
    formattedPrice,
    formattedItemValue,
    itemValueNumber,
    discountFormatted,
  };
}
